import React from 'react';
import { useAuth, LoginHeader } from '@vfpf/vfpf-shared';
import { Footer } from './Footer';
import { Header } from './Header';
import { LoginFooterSSA } from './LoginFooterSSA';

export const ApplicationContainer: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { authState } = useAuth();
  const isAuthenticated = authState.status === 'authenticated';

  return (
    <div id="applicationContainer" className={isAuthenticated ? '' : 'min-vh-0'}>
      {isAuthenticated ? (
        <>
          <Header />
          <div className="container">
            <main role="main">{children}</main>
          </div>
          <Footer />
        </>
      ) : (
        <>
          <header>
            <LoginHeader variant="ssa" />
          </header>
          <main role="main">{children}</main>
          <LoginFooterSSA />
        </>
      )}
    </div>
  );
};
